import React, { useEffect, useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import { IoIdCardOutline, IoQrCodeOutline, IoAlertCircleOutline } from "react-icons/io5"
import { alertToast } from "../helpers/alertToast"
import AppLayout from "../layout/AppLayout"
import CredencialService from "../services/CredencialService"
import LoaderComponent from "../components/LoaderComponent"

const Credencial = ({ user }) => {
  const [front, setFront] = useState(null)
  const [back, setBack] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const fetchCredencials = async () => {
    setLoading(true)
    setError(false)
    try {
      const [f, b] = await Promise.all([
        CredencialService.getCredencialFrente(user.cuit),
        CredencialService.getCredencialDorso(user.cuit),
      ])
      setFront(f)
      setBack(b)
    } catch (err) {
      console.error("Error al obtener credencial:", err)
      alertToast("Error", "No se pudo obtener la credencial.")
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  const flipCredencial = () => {
    document.getElementById("credencial")?.classList.toggle("rotate")
  }

  useEffect(() => {
    fetchCredencials()
    document.title = "Mi Credencial"
  }, [])

  return (
    <AppLayout back="/">
      <Container>
        <Row className="mb-2">
          <Col xs={12}>
            <h5 className="fw-light border-bottom border-gray pb-2">
              <IoIdCardOutline /> Mi Credencial
            </h5>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            {loading ? (
              <LoaderComponent text="Buscando Credencial..." />
            ) : error || !front || !back ? (
              <div className="text-center">
                <IoAlertCircleOutline size={128} className="text-muted m-5" />
                <p className="text-muted">
                  No se pudo obtener la credencial.<br />
                  Por favor, comunicate con la Oficina de Atención a los Equipos Legislativos (OFALEGIS).<br />
                  Internos 3010 / 3011 de 10 a 17 hs. de lunes a viernes.<br />
                  <strong>¡Gracias!</strong>
                </p>
              </div>
            ) : (
              <>
                <div
                  id="container-credencial"
                  className="container-credencial"
                  onClick={flipCredencial}
                >
                  <div className="credencial" id="credencial">
                    <div className="credencial-front">
                      <img src={front} alt="Frente de credencial" className="img-fluid" />
                    </div>
                    <div className="credencial-back">
                      <img src={back} alt="Dorso de credencial" className="img-fluid" />
                    </div>
                  </div>
                </div>

                <Row>
                  <Col xs={12} className="text-center mt-3">
                    <a href="/qr" className="btn btn-primary btn-legis btn-lg">
                      <IoQrCodeOutline /> Generar QR
                    </a>
                  </Col>
                </Row>
              </>
            )}
          </Col>
        </Row>
      </Container>
    </AppLayout>
  )
}

export default Credencial
